import React from "react";
import styles from "./ProductListPage.module.css";
import PropTypes from "prop-types";
import { ProductTable } from "admin/components/Product";
import Button from "@material-ui/core/Button";
import { RouterPrivateName } from "shared/RouterPrivateName";
import history from "core/helper/Helper";

function ProductListPage(props) {
  const handelToCreatePage = () => {
    history.push(RouterPrivateName.Product.Create.url);
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Button
          variant="contained"
          color="primary"
          onClick={handelToCreatePage}
        >
          Thêm Sản Phẩm
        </Button>

        <Button
          variant="contained"
          color="secondary"
          onClick={() => history.push(RouterPrivateName.HomePage.url)}
        >
          Home
        </Button>
      </div>
      <ProductTable />
    </div>
  );
}

ProductListPage.propTypes = {};

export default ProductListPage;
